// extracted by mini-css-extract-plugin
export default {"imageCell":"Order__imageCell___RItGH","statusCell":"Order__statusCell___2kjJ8","row":"Order__row___3gTvr","cell":"Order__cell___2eoDT"};